import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Button, Modal, Form, Offcanvas } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import withPermission from '../../../utils/withPermission';
import Swal from 'sweetalert2';
import CreatableSelect from 'react-select/creatable';
import { FaPlus } from 'react-icons/fa';
import { saveAs } from "file-saver";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const API_URL = `${backendUrl}/api/expense-type`;
const CATEGORY_API_URL = `${backendUrl}/api/categories?type=expense`;
const webzashUrl = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration'; // Adjust as needed

const ExpenseTypeDetails = () => {
    const [expenseTypes, setExpenseTypes] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ name: '' });
    const [isEdit, setIsEdit] = useState(false);
    const [selectedExpenseType, setSelectedExpenseType] = useState(null);
    const didFetchRef = useRef(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [errors, setErrors] = useState({});
    const WithEditPermission = withPermission(({ children }) => children, ['expensetype-edit']);
    const WithDeletePermission = withPermission(({ children }) => children, ['expensetype-delete']);
    const WithCreatePermission = withPermission(({ children }) => children, ['expensetype-create']);
    const [searchQuery, setSearchQuery] = useState('');
    const debounceTimeoutRef = useRef(null);
    const [categories, setCategories] = useState([]);
    const [showCategoryModal, setShowCategoryModal] = useState(false);

    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchExpenseTypes(1, searchQuery);
        }, searchQuery ? 1500 : 0);

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchQuery]);
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);

    };

    const fetchExpenseTypes = async (page = 1) => {
        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const response = await axios.get(`${API_URL}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: {
                    page,
                    search: searchQuery,
                },
            });
            setExpenseTypes(response.data.expense.data);
            setPageCount(response.data.expense.last_page);
            setCurrentPage(response.data.expense.current_page);


        } catch (error) {
            console.error('Error fetching expenseTypes:', error);
        }
    };

    const fetchCategories = async () => {
        try {
            const token = JSON.parse(localStorage.getItem('user-info'))?.token;
            const origin = localStorage.getItem('user-origin');
            const response = await axios.get(CATEGORY_API_URL, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,

            });
            setCategories(response.data.category);
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };
    const handleAddExpenseType = () => {
        setFormData({ name: '', description: '', category_id: '', is_petty_cash: false, is_deferred: false });
        setIsEdit(false);
        setSelectedExpenseType(null);
        setShowModal(true);
        setErrors({});
        fetchCategories();

    };

    const handleEditExpenseType = (expensetype) => {
        setFormData({
            ...expensetype,
            is_petty_cash: expensetype.is_petty_cash === 'true' ? true : false,
            is_deferred: expensetype.is_deferred === 'true' ? true : false,

        });
        setIsEdit(true);
        setSelectedExpenseType(expensetype);
        setShowModal(true);
        setErrors({});
        fetchCategories();
    };


    // const handleDelete = async (id) => {
    //     Swal.fire({
    //         title: "Are you sure?",
    //         text: "You won't be able to revert this!",
    //         icon: "warning",
    //         showCancelButton: true,
    //         confirmButtonColor: "#d33",
    //         cancelButtonColor: "#3085d6",
    //         confirmButtonText: "Yes, delete it!"
    //     }).then(async (result) => {
    //         if (result.isConfirmed) {
    //             try {
    //                 const userInfo = JSON.parse(localStorage.getItem('user-info'));
    //                 const origin = localStorage.getItem('user-origin');
    //                 const token = userInfo?.token;
    //                 await axios.delete(`${API_URL}/${id}`, {
    //                     headers: {
    //                         Authorization: `Bearer ${token}`,
    //                         'Tenant-Origin': origin,
    //                     },
    //                 });
    //                 setExpenseTypes(expenseTypes.filter(expensetype => expensetype.id !== id));
    //                 Swal.fire(
    //                     "Deleted!",
    //                     "The expensetype has been deleted.",
    //                     "success"
    //                 );
    //             } catch (error) {
    //                 console.error('Error deleting expensetype:', error);
    //                 Swal.fire(
    //                     "Error!",
    //                     "Failed to delete expensetype. Please try again.",
    //                     "error"
    //                 );
    //             }
    //         }
    //     });

    // };

    // const handleInputChange = (e) => {
    //     const { name, value} = e.target;

    //     // Ensure that we handle the radio button correctly
    //     if (name === "status") {
    //         setFormData((prev) => ({
    //             ...prev,
    //             status: value,
    //         }));
    //     } 
    //     setErrors((prevErrors) => ({
    //         ...prevErrors,
    //         [name]: undefined,
    //     }));
    // };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Update the form state
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: undefined,
        }));
    };




    const handlePageChange = ({ selected }) => {
        const newPage = selected + 1;
        setCurrentPage(newPage);
        fetchExpenseTypes(newPage);
    };

    useEffect(() => {
        if (!showModal) {
            setErrors({});
        }
    }, [showModal]);
    // const validateForm = () => {
    //     const newErrors = {};
    //     if (!formData.name) newErrors.name = 'Name is required';

    //     const isDuplicate = categories.some(cat => {
    //         const catName = cat.name?.trim().toLowerCase();

    //         if (isEdit && cat.id === selectedCategory?.id) {
    //             return false;
    //         }

    //         return (
    //             catName === name &&
    //             String(cat.category_id) === String(categoryId)
    //         );
    //     });

    //     if (isDuplicate) {
    //         newErrors.name = 'This expense type already exists in this category';
    //     }


    //     return newErrors;
    // };
const validateForm = () => {
    const newErrors = {};

    const expenseTypeName = formData.name?.trim().toLowerCase();
    const expenseCategoryId = formData.category_id;
    const currentId = isEdit ? formData.id : null;

    if (!expenseTypeName) {
        newErrors.name = 'Name is required';
        return newErrors;
    }

    // Check against existing expense types (not categories)
    const isDuplicate = expenseTypes.some(item => {
        const existingName = item.name?.trim().toLowerCase();
        const existingCategoryId = item.category_id;

        // Skip same record during edit
        if (currentId && item.id === currentId) {
            return false;
        }

        return (
            existingName === expenseTypeName &&
            String(existingCategoryId) === String(expenseCategoryId)
        );
    });

    if (isDuplicate) {
        newErrors.name = 'This expense type already exists in this category';
    }

    return newErrors;
};

   
    const [loading, setLoading] = useState(false);
    // 1. Create or update Webzash Group and Ledger when expense type is added/edited
    const [selectedWebzashGroup, setSelectedWebzashGroup] = useState('');
    const [allWebzashGroups, setAllWebzashGroups] = useState([]);
    const [expenseGroups, setExpenseGroups] = useState([]); // children under Expenses
    const [assetGroups, setAssetGroups] = useState([]);

    const fetchWebzashGroups = async () => {
        try {
            const response = await axios.get(`${webzashUrl}/api/groups/index`, {
                headers: {
                    'x-api-key': process.env.REACT_APP_API_KEY,
                    'Accept': 'application/json'
                },
            });
            return response.data;
            // setAllWebzashGroups(allGroups);
            // const expensesGroup = allGroups.find(g => g.Group.name?.toLowerCase() === 'expenses' || g.Group.name === 'Expenses');
            // const assetsGroup = allGroups.find(g => g.Group.name?.toLowerCase() === 'assets' || g.Group.name === 'Assets');

            // const expenseChildren = allGroups.filter(g => String(g.Group.parent_id) === String(expensesGroup?.Group?.id));
            // const assetChildren = allGroups.filter(g => String(g.Group.parent_id) === String(assetsGroup?.Group?.id));

            // setExpenseGroups(expenseChildren);
            // setAssetGroups(assetChildren);
        } catch (error) {
            console.error("Failed to fetch Webzash groups:", error);
            return [];
        }
    };

    const createWebzashGroupIfNotExists = async (groupName, parentGroupName = 'Expenses') => {
        if (!groupName || typeof groupName !== 'string') {
            console.error("Invalid group name provided:", groupName);
            return;
        }

        const groups = await fetchWebzashGroups();

        const parentGroup = groups.find(g => g?.Group?.name === parentGroupName);
        const exists = groups.find(g => g?.Group?.name?.toLowerCase() === groupName.toLowerCase());

        if (!exists && parentGroup) {
            try {
                const groupPayload = {
                    Group: {
                        name: groupName,
                        parent_id: parentGroup.Group.id,
                        code: null,
                        affects_gross: 1,
                    }
                };
                await axios.post(`${webzashUrl}/api/groups/add`, groupPayload, {
                    headers: {
                        'x-api-key': process.env.REACT_APP_API_KEY,
                        'Accept': 'application/json'
                    }
                });
                console.log(`Group '${groupName}' created under '${parentGroupName}'`);
            } catch (err) {
                console.error("Error creating group:", err);
            }
        }
    };


    // const createOrUpdateLedger = async (ledgerName, groupName, isEdit = false, existingLedger = null) => {
    //     try {
    //         const groups = await fetchWebzashGroups();
    //         const group = groups.find(g => g.Group.name === groupName);
    //         if (!group) return;

    //         let deductionRate = 100; // default
    //         const lowerName = ledgerName.toLowerCase();
    //         if (lowerName.includes("entertainment")) {
    //             deductionRate = 50;
    //         } else if (lowerName.includes("fine") || lowerName.includes("penalty")) {
    //             deductionRate = 0;
    //         }

    //         const ledgerPayload = {
    //             Ledger: {
    //                 name: ledgerName,
    //                 group_id: group.Group.id,
    //                 op_balance_dc: 'D',
    //                 op_balance: 0,
    //                 notes: '',
    //                 code: null,
    //                 type: 0,              // 0 = Normal account, 1 = Bank/Cash (based on Webzash docs)
    //                 reconciliation: 0,
    //                 deduction_rate: deductionRate
    //             }
    //         };

    //         if (isEdit && existingLedger) {
    //             await axios.put(`${webzashUrl}/api/ledgers/edit/${existingLedger.Ledger.id}`, ledgerPayload, {
    //                 headers: {
    //                     'x-api-key': process.env.REACT_APP_API_KEY,
    //                     'Accept': 'application/json'
    //                 }
    //             });
    //             console.log("Ledger updated successfully");
    //         } else {
    //             const ledgers = await axios.get(`${webzashUrl}/api/ledgers/index`, {
    //                 headers: {
    //                     'x-api-key': process.env.REACT_APP_API_KEY,
    //                     'Accept': 'application/json'
    //                 }
    //             });

    //             const ledgerList = ledgers?.data?.data || [];
    //             const alreadyExists = ledgerList.find(
    //                 l => l?.Ledger?.name?.toLowerCase() === ledgerName.toLowerCase()
    //             );

    //             if (!alreadyExists) {
    //                 await axios.post(`${webzashUrl}/api/ledgers/add`, ledgerPayload, {
    //                     headers: {
    //                         'x-api-key': process.env.REACT_APP_API_KEY,
    //                         'Accept': 'application/json'
    //                     }
    //                 });
    //                 console.log("Ledger created successfully");
    //             }
    //         }
    //     } catch (error) {
    //         console.error("Ledger create/update failed:", error);
    //     }
    // };

    const createOrUpdateLedger = async (ledgerName, groupName, isEdit = false, existingLedger = null) => {
        try {
            const groups = await fetchWebzashGroups();
            const group = groups.find(g => g.Group.name === groupName);
            if (!group) return;

            let deductionRate = 100; // default
            const lowerName = ledgerName.toLowerCase();
            if (lowerName.includes("entertainment")) {
                deductionRate = 50;
            } else if (lowerName.includes("fine") || lowerName.includes("penalty")) {
                deductionRate = 0;
            }

            const ledgerPayload = {
                Ledger: {
                    name: ledgerName,
                    group_id: group.Group.id,
                    op_balance_dc: 'D',
                    op_balance: 0,
                    notes: '',
                    code: null,
                    type: 0,
                    reconciliation: 0,
                    deduction_rate: deductionRate
                }
            };

            if (isEdit && existingLedger) {
                // Try using POST method instead of PUT
                try {
                    await axios.post(`${webzashUrl}/api/ledgers/edit/${existingLedger.Ledger.id}`, ledgerPayload, {
                        headers: {
                            'x-api-key': process.env.REACT_APP_API_KEY,
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        }
                    });
                    console.log("Ledger updated successfully using POST");
                } catch (postError) {
                    console.log("POST failed, trying PUT as fallback...");
                    // Fallback to PUT if POST fails
                    await axios.put(`${webzashUrl}/api/ledgers/edit/${existingLedger.Ledger.id}`, ledgerPayload, {
                        headers: {
                            'x-api-key': process.env.REACT_APP_API_KEY,
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        }
                    });
                    console.log("Ledger updated successfully using PUT");
                }
            } else {
                const ledgers = await axios.get(`${webzashUrl}/api/ledgers/index`, {
                    headers: {
                        'x-api-key': process.env.REACT_APP_API_KEY,
                        'Accept': 'application/json'
                    }
                });

                const ledgerList = ledgers?.data?.data || [];
                const alreadyExists = ledgerList.find(
                    l => l?.Ledger?.name?.toLowerCase() === ledgerName.toLowerCase()
                );

                if (!alreadyExists) {
                    await axios.post(`${webzashUrl}/api/ledgers/add`, ledgerPayload, {
                        headers: {
                            'x-api-key': process.env.REACT_APP_API_KEY,
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        }
                    });
                    console.log("Ledger created successfully");
                }
            }
        } catch (error) {
            console.error("Ledger create/update failed:", error.response?.status, error.response?.data);
        }
    };
    const deleteLedgerByName = async (ledgerName) => {
        try {
            const response = await axios.get(`${webzashUrl}/api/ledgers/index`, {
                headers: {
                    'x-api-key': process.env.REACT_APP_API_KEY,
                    'Accept': 'application/json'
                }
            });
            const ledgers = response.data?.data || [];
            const ledgerToDelete = ledgers.find(l => l.Ledger.name.toLowerCase() === ledgerName.toLowerCase());

            if (ledgerToDelete) {
                // await axios.delete(`${webzashUrl}/api/ledgers/delete/${ledgerToDelete.Ledger.id}`, {
                //     headers: {
                //         'x-api-key': process.env.REACT_APP_API_KEY,
                //         'Accept': 'application/json'
                //     }
                // });
                await axios.post(`${webzashUrl}/api/ledgers/delete/${ledgerToDelete.Ledger.id}`, {}, {
                    headers: {
                        'x-api-key': process.env.REACT_APP_API_KEY,
                        'Accept': 'application/json'
                    }
                });

                console.log("Ledger deleted successfully");
            }
        } catch (err) {
            console.error("Failed to delete ledger:", err);
        }
    };
    const getLedgerByName = async (name) => {
        try {
            const response = await axios.get(`${webzashUrl}/api/ledgers/index`, {
                headers: {
                    'x-api-key': process.env.REACT_APP_API_KEY,
                    'Accept': 'application/json'
                }
            });
            const ledgers = response.data?.data || [];
            return ledgers.find(l => l?.Ledger?.name?.toLowerCase() === name.toLowerCase());
        } catch (err) {
            console.error("Failed to fetch existing ledger:", err);
            return null;
        }
    };

    const showSuccessToast = (title) => {
        Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: title,
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            }
        });
    };

    const handleSubmit = async () => {
        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        const origin = localStorage.getItem('user-origin');
        const token = userInfo?.token;
        const validationErrors = validateForm();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return;
        }

        try {
            const selectedCategory = categories.find(cat => String(cat.id) === String(formData.category_id));
            if (!selectedCategory) {
                setErrors(prev => ({ ...prev, category_id: "Please select a valid category." }));
                setLoading(false);
                return;
            }

            const groupName = selectedCategory?.name?.trim();
            const ledgerName = formData.name?.trim();
            await createWebzashGroupIfNotExists(groupName);


            // Get ledger (try new name first, fallback to old name)
            let existingLedger = await getLedgerByName(ledgerName);
            if (!existingLedger && isEdit && selectedExpenseType?.name) {
                existingLedger = await getLedgerByName(selectedExpenseType.name);
            }

            if (isEdit && selectedExpenseType?.id) {
                const response = await axios.put(`${API_URL}/${selectedExpenseType.id}`, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });

                setExpenseTypes(expenseTypes.map(ind =>
                    ind.id === selectedExpenseType.id ? response.data.expense : ind
                ));

                await createOrUpdateLedger(ledgerName, groupName, true, existingLedger);  // ✅ only edit
                showSuccessToast('Expense Type updated successfully ✅');
            }
            else {
                const response = await axios.post(API_URL, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });

                // ✅ Only push when creating
                setExpenseTypes([...expenseTypes, response.data.expense]);

                await createOrUpdateLedger(ledgerName, groupName, false);
                showSuccessToast('Expense Type added successfully ✅');
            }

            setShowModal(false);
        } catch (error) {
            console.error("Unexpected error:", error);
        }
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;
                    const deletedItem = expenseTypes.find(e => e.id === id);

                    await axios.delete(`${API_URL}/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });

                    await deleteLedgerByName(deletedItem.name);

                    setExpenseTypes(expenseTypes.filter(expensetype => expensetype.id !== id));
                    Swal.fire("Deleted!", "The expensetype has been deleted.", "success");
                } catch (error) {
                    console.error('Error deleting expensetype:', error);
                    Swal.fire("Error!", "Failed to delete expensetype. Please try again.", "error");
                }
            }
        });
    };



    // const handleSubmit = async () => {
    //     const userInfo = JSON.parse(localStorage.getItem('user-info'));
    //     const origin = localStorage.getItem('user-origin');
    //     const token = userInfo?.token;
    //     const validationErrors = validateForm();
    //     if (Object.keys(validationErrors).length > 0) {
    //         setErrors(validationErrors);
    //         setLoading(false);
    //         return; // Stop here if validation fails
    //     }
    //     try {
    //         if (isEdit) {
    //             const response = await axios.put(`${API_URL}/${selectedExpenseType.id}`, formData, {
    //                 headers: {
    //                     Authorization: `Bearer ${token}`,
    //                     'Tenant-Origin': origin,
    //                 },
    //             });
    //             setExpenseTypes(expenseTypes.map(ind => (ind.id === selectedExpenseType.id ? response.data.expense : ind)));
    //         } else {
    //             const response = await axios.post(API_URL, formData, {
    //                 headers: {
    //                     Authorization: `Bearer ${token}`,
    //                     'Tenant-Origin': origin,
    //                 },
    //             });
    //             setExpenseTypes([...expenseTypes, response.data.expense]);
    //         }
    //         setShowModal(false);
    //     } catch (error) {
    //         {
    //             console.error('Unexpected error: ', error);
    //         }
    //     }
    // };

    const filteredExpenseTypes = expenseTypes.filter(expensetype => !expensetype.parent_id);
    const handleCategoryChange = (selectedOption) => {
        setFormData((prev) => ({ ...prev, category_id: selectedOption.value }));
    };

    const handleCategoryCreate = async (inputValue) => {
        try {
            const token = JSON.parse(localStorage.getItem('user-info'))?.token;

            const origin = localStorage.getItem('user-origin');

            const response = await axios.post(CATEGORY_API_URL, { name: inputValue }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin
                },
            });
            const newCategory = response.data.category;
            setCategories([...categories, newCategory]);
            setFormData((prev) => ({ ...prev, category_id: newCategory.id }));
        } catch (error) {
            console.error('Error adding category:', error);
        }
    };

    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
        },
    });

    const handleExport = async () => {
        try {
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem("user-origin");
            const token = userInfo?.token;

            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/expense-type/export`, {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                },
            });

            const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            saveAs(blob, "expensetype.xlsx");

            Toast.fire({
                icon: "success",
                title: "ExpenseType exported successfully!",
            });
        } catch (error) {
            console.error("Export error:", error);
            Toast.fire({
                icon: "error",
                title: "Export failed! Please try again.",
            });
        }
    };

    const handleImport = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("file", file);

        try {
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem("user-origin");
            const token = userInfo?.token;

            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/expense-type/import`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                },
            });

            Toast.fire({
                icon: "success",
                title: "ExpenseType imported successfully!",
            });
            setTimeout(() => window.location.reload(), 1000);

            e.target.value = "";
        } catch (error) {
            console.error("Import error:", error);

            let message = "Import failed! Please check your file.";

            if (error.response?.status === 422 && error.response?.data?.errors) {
                message = error.response.data.errors.join("\n");
            } else if (error.response?.data?.message) {
                message = error.response.data.message;
            }

            Toast.fire({
                icon: "warning",
                title: message,
            });
            e.target.value = "";
        }

    };

    const handleTypeChange = (e) => {
        const newType = e.target.value;
        setFormData(prev => ({ ...prev, category_type: newType, group_id: "" }));
        setSelectedWebzashGroup("");
    };
    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid ">
                    <div className="row w-100">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Expense Type</h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        {/* <li className="breadcrumb-item"><a href="javascript:void(0);">ExpenseType</a></li> */}
                                        {/* <li className="breadcrumb-item active">ExpenseType List</li> */}
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between mb-3">
                                        <div className="d-flex">
                                            <div className="search-box me-2 mb-2 d-inline-block">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control font-size-12"
                                                        placeholder="Search..."
                                                        value={searchQuery}
                                                        onChange={handleSearchChange}
                                                    />
                                                    <i className="bx bx-search-alt search-icon" />
                                                </div>
                                            </div>



                                        </div>

                                        {/* <WithCreatePermission>
                                            <button
                                                type="button"
                                                className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"

                                                onClick={handleAddExpenseType} data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Add ExpenseType"
                                            >
                                                <i className="mdi mdi-plus" style={{ fontSize: "16px" }}></i>
                                            </button>
                                        </WithCreatePermission> */}
                                        <div className="d-flex align-items-center gap-2">
                                            <button
                                                type="button"
                                                className="btn btn-light border"
                                                onClick={handleExport}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Export to Excel"
                                            >
                                                <i className="mdi mdi-file-excel text-success"></i>
                                            </button>

                                            <input
                                                type="file"
                                                accept=".xlsx, .xls"
                                                id="importFile"
                                                onChange={handleImport}
                                                style={{ display: "none" }}
                                            />
                                            <label
                                                htmlFor="importFile"
                                                className="btn btn-light border mb-0"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Import from Excel"
                                            >
                                                <i className="mdi mdi-upload text-primary"></i>
                                            </label>

                                            <WithCreatePermission>
                                                <button
                                                    type="button"
                                                    className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"
                                                    onClick={() => handleAddExpenseType()}
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="Add ExpenseType"
                                                >
                                                    <i className="mdi mdi-plus"></i>
                                                </button>
                                            </WithCreatePermission>
                                        </div>
                                    </div>
                                    <table className="table align-middle table-nowrap table-check table-list">

                                        <thead className="table-light">
                                            <tr>
                                                <th style={{ width: '20px' }} className="align-middle">
                                                    <div className="form-check font-size-16">
                                                        <input className="form-check-input" type="checkbox" id="checkAll" />
                                                        <label className="form-check-label" htmlFor="checkAll"></label>
                                                    </div>
                                                </th>
                                                <th className="align-middle text-start">#</th>

                                                <th className="align-middle text-start"> Category</th>
                                                <th className="align-middle text-start"> Type</th>

                                                <th className="align-middle text-start"> Description</th>
                                                <th className="align-middle text-start"> Deferred</th>
                                                {/* <th className="align-middle">Petty Cash</th> */}

                                                <th className="">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Array.isArray(expenseTypes) && expenseTypes.length > 0 ? (
                                                expenseTypes.map((expensetype, index) => (
                                                    <tr key={expensetype.id}>
                                                        <td>
                                                            <div className="form-check font-size-16">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id={`instanceCheck${index}`}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor={`instanceCheck${index}`}
                                                                ></label>
                                                            </div>
                                                        </td>
                                                        <td className="text-start">{index + 1}</td>
                                                        <td className="text-start">{expensetype?.category?.name}</td>

                                                        <td className="text-start">{expensetype.name}</td>
                                                        <td className="text-start narration-cell" title={expensetype.description || ""}>
                                                            {expensetype.description}</td>
                                                        <td className="text-start">
                                                            {expensetype.is_deferred ? (
                                                                <span className="badge bg-info bg-soft text-info">Deferred</span>
                                                            ) : (
                                                                <span className="badge bg-secondary bg-soft text-secondary">Normal</span>
                                                            )}
                                                        </td>

                                                        {/* <td>
                                                                    {expensetype.is_petty_cash ? (
                                                                        <span className="badge bg-success bg-soft text-success">Yes</span>
                                                                    ) : (
                                                                        <span className="badge bg-danger bg-soft text-danger">No</span>
                                                                    )}
                                                                </td> */}
                                                        <td>
                                                            <div className="dropdown">
                                                                <i
                                                                    className="mdi mdi-dots-horizontal font-size-18"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                    style={{ cursor: 'pointer' }}
                                                                ></i>
                                                                <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                    <li><WithEditPermission>
                                                                        <button className="dropdown-item" onClick={() => handleEditExpenseType(expensetype)}>
                                                                            Edit
                                                                        </button></WithEditPermission>
                                                                    </li>
                                                                    <li><WithDeletePermission>
                                                                        <button className="dropdown-item" onClick={() => handleDelete(expensetype.id)}>
                                                                            Delete
                                                                        </button></WithDeletePermission>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" className="text-center">
                                                        No expenseTypes found.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    <div className="d-flex justify-content-end pagination-sm">
                                        <ReactPaginate
                                            previousLabel={'<'}
                                            nextLabel={'>'}
                                            breakLabel={'...'}
                                            pageCount={pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={3}
                                            onPageChange={handlePageChange}
                                            containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item previous'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item next'}
                                            nextLinkClassName={'page-link'}
                                            breakClassName={'page-item'}
                                            breakLinkClassName={'page-link'}
                                            activeClassName={'active'}
                                        />
                                    </div>
                                    {/* Modal for Add/Edit ExpenseType */}
                                    <Offcanvas show={showModal} onHide={() => setShowModal(false)} placement='end' style={{ width: '480px' }}>
                                        <Offcanvas.Header closeButton>
                                            <Offcanvas.Title>{isEdit ? 'Edit ExpenseType' : 'Add ExpenseType'}</Offcanvas.Title>
                                        </Offcanvas.Header>
                                        <hr style={{ margin: 0 }} /><br />

                                        <Offcanvas.Body>
                                            <Form>
                                                <Form.Group controlId="expenseCategory" className="mb-3">
                                                    <Form.Label style={{ fontSize: '13px' }}>Category</Form.Label>
                                                    <Form.Select
                                                        style={{ fontSize: '13px' }}
                                                        value={formData.category_id || ""}
                                                        onChange={(e) => setFormData(prev => ({
                                                            ...prev,
                                                            category_id: e.target.value
                                                        }))}
                                                    >
                                                        <option value="">Select Category</option>
                                                        {categories.map(cat => (
                                                            <option key={cat.id} value={cat.id}>{cat.name}</option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>

                                                <Form.Group controlId="expensetypeName" className="mb-3">
                                                    <Form.Label style={{ fontSize: '13px' }}>Expense Type</Form.Label>
                                                    <Form.Control type="text" name="name" style={{ fontSize: '13px' }} value={formData.name} onChange={handleInputChange}
                                                        className={`form-control ${errors?.name ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.name && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.name}</div>}

                                                </Form.Group>

                                                <Form.Group controlId="expensetypedesc" className="mb-3">
                                                    <Form.Label style={{ fontSize: '13px' }}>Description</Form.Label>
                                                    <Form.Control
                                                        as="textarea"  // Change from text input to textarea
                                                        name="description"
                                                        style={{ fontSize: '13px', minHeight: '100px' }} // Adjust height if needed
                                                        value={formData.description} // Bind to description field
                                                        onChange={handleInputChange}
                                                        className="form-control"
                                                    />
                                                </Form.Group><br />

                                                <Form.Group controlId="isDeferred" className="mb-3">
                                                    <Form.Check
                                                        type="checkbox"
                                                        label="Deferred Expense"
                                                        checked={formData.is_deferred}
                                                        onChange={(e) =>
                                                            setFormData(prev => ({ ...prev, is_deferred: e.target.checked }))
                                                        }
                                                        style={{ fontSize: '13px' }}
                                                    />
                                                </Form.Group>

                                                {/* <Form.Group controlId="isPettyCash" className="mb-3">
                                                    <Form.Check
                                                        type="checkbox"
                                                        label="Is Petty Cash"
                                                        checked={formData.is_petty_cash}
                                                        onChange={(e) =>
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                is_petty_cash: e.target.checked,
                                                            }))
                                                        }
                                                        style={{ fontSize: '13px' }}
                                                    />
                                                </Form.Group> */}







                                            </Form>
                                        </Offcanvas.Body>
                                        <div className="p-3 d-flex justify-content-end border-top">
                                            <Button variant="secondary me-2" onClick={() => setShowModal(false)}>Close</Button>
                                            <Button variant="secondary" onClick={handleSubmit}>{isEdit ? 'Update' : 'Save'} </Button>
                                        </div>
                                    </Offcanvas>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExpenseTypeDetails;

